import styled, {css} from 'styled-components'

export const StyledIconContainer = styled.div<{$size: 'md' | 'lg'; $variant: 'neutral' | 'primary'}>(
    ({$size, $variant, theme: {palette}}) => css`
        width: ${$size == 'lg' ? '48px' : '40px'};
        height: ${$size == 'lg' ? '48px' : '40px'};
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid ${$variant == 'neutral' ? palette.neutral['200'] : palette.primary[200]};
        background-color: ${$variant == 'neutral' ? palette.neutral.white : palette.primary[100]};

        svg {
            width: ${$size == 'lg' ? '24px' : '20px'};
        }
    `
)
